export function normalizeLocaleName(locale: string): string {
  return locale.replace(/-/g, '_');
}
